import { jsx as r, jsxs as t } from "react/jsx-runtime";
import o from "./chunk603.js";
import n from "clsx";
import { Main as a } from "./chunk197.js";
import { IconSmallError as i } from "./chunk84.js";
import { H1 as c } from "./chunk187.js";
import { ErrorBoundary as m } from "./chunk604.js";
import { Description as l } from "./chunk31.js";
import { PrimaryButton as s } from "./chunk4.js";
const d = () => {
  const e = () => {
    window.location.reload();
  };
  return /* @__PURE__ */ r(a, { className: o.errorPage, withoutMenu: !0, children: /* @__PURE__ */ t("section", { className: n(o.errorPageContent, o.errorPageSection), children: [
    /* @__PURE__ */ r("div", { className: o.errorPageContentIcon, "aria-hidden": "true", children: /* @__PURE__ */ r(i, {}) }),
    /* @__PURE__ */ r(c, { type: "bold", children: "Не получается открыть страницу" }),
    /* @__PURE__ */ r(l, { className: o.errorPageContentDescription, children: "Что-то пошло не так, попробуйте еще раз или напишите в поддержку" }),
    /* @__PURE__ */ r(s, { onClickButton: e, className: o.errorPageContentButton, children: "Попробовать еще раз" })
  ] }) });
}, E = ({ children: e }) => /* @__PURE__ */ r(m, { fallback: /* @__PURE__ */ r(d, {}), showDialog: !0, children: e });
export {
  E as ErrorBoundary,
  d as ErrorPage
};
